const images = {
    logo: require('~/assets/images/logo.svg').default,
    noImage: require('~/assets/images/no-image.png'),
};

export default images;
